import React from 'react';
import { Link } from 'react-router-dom';
export function SwitchTeaser() {
  return <section className="w-full bg-[#F5F4F1] py-24 px-4 border-t border-[#E8E6E3]" data-id="element-113">
      <div className="max-w-5xl mx-auto text-center" data-id="element-114">
        <div className="max-w-3xl mx-auto" data-id="element-115">
          <h2 className="text-3xl md:text-[2.75rem] font-medium tracking-tight text-[#0F0F0F] leading-[1.1] mb-5" data-id="element-116">
            Switch to Andoe
          </h2>
          <p className="text-lg text-[#5C5C5C] leading-relaxed mb-10" data-id="element-117">
            See why teams are choosing clarity over complexity.
          </p>
          <Link to="/switch" className="inline-flex items-center px-6 py-3 text-base font-medium rounded-lg bg-[#1A1A1A] text-white hover:bg-[#0F0F0F] transition-colors duration-200" data-id="element-118">
            Learn more
          </Link>
        </div>
      </div>
    </section>;
}